/**
  *  字典类数据
  *  @author  liuguisheng
  *  @date  2019-9-21
  *  
*/

/** @name 表单项类型与名称对应字典表
 *  @author 王汝鹏
 *  @version 2019-11-22
 */
export const formTypeNameDictionary = new Map([
    ["text",        "文字"],
    ["button",      "按钮"],
    ["input",       "单行文本"],
    ["textarea",    "多行文本"],
    ["radio",       "单选框组"],
    ["checkbox",    "多选框组"],
    ["select",      "下拉选择器"],
    ["switch",      "开关"],
    ["datePicker",  "日期选择器"],
    ["timePicker",  "时间选择器"],
    ["line",        "分割线"],
    ["uploadImage", "上传图片"],
    ["uploadFile",  "上传文件"],
    ["grid",        "栅格布局"],
    ["free",        "任意门"]
])

/** @name 所有表单项类型的自定义名称最大索引记录对象()
 *  @author 王汝鹏
 *  @version 2019-11-22
 */
export const allFormTypeIndex = new Map([
    ["text",        0],
    ["button",      0],
    ["input",       0],
    ["textarea",    0],
    ["radio",       0],
    ["checkbox",    0],
    ["select",      0],
    ["switch",      0],
    ["datePicker",  0],
    ["timePicker",  0],
    ["line",        0],
    ["uploadImage", 0],
    ["uploadFile",  0],
    ["grid",        0],
    ["free",        0]
]);

/** @name 当前类型组件是否提供勾选功能
 *  @author liuguisheng
 *  @version 2019-12-28
 */
export const isHasPickDic = {
              text: true,
              button: false,
              input: true,
              textarea: true,
              radio: true,
              checkbox: true,
              select: true,
              switch: true,
              datePicker: true,
              timePicker: true,
              uploadImage: true,
              uploadFile: false,
              grid: false,
              free: false,
              line: false,
              domain: false
            }



/** 表单项配置字典 **/
export const formConfigMap = {
  /*************************************
   *************************************
   *************    文字    *************
   *************************************
   *************************************/
  text: {
    node: {
      type: 'text',
      selfId: undefined,
      isCopied: false,
      copiedCount: 0
    },
    baseOption: {
      labelName: '文字',
      customName: '',
      isDisplay: true
    },
    styleOption: {
      customClass: undefined,
      width: 5,
      title: '12',
      color: "#5c5c5c",
      paddingLeft: 0

    },
    renderOption: {
      strong: 'none',
      underline: 'none',
      italic: 'none',
      wrap: false,
      lineHeight: '2.5',
      indent: 0,
      align: 'none',
      fontSize: 14,
      showRule: 'all',
      seat: '',
      whereColor: 'all',
      renderColor: '#5c5c5c'
    },
    event: {
      emit: [],
      on: []
    }
  },
  /*************************************
   *************************************
   *************    按钮    *************
   *************************************
   *************************************/
  button: {
    node: {
      type: 'button',
      selfId:undefined,
      isCopied:false,
      copiedCount:0
    },
    baseOption: {
      labelName: '按钮',
      model:'',
      customName:'',
      buttonType:'primary',
      buttonSize:'undefined',
      buttonBack:false,
      buttonLoading:false,
      buttonThrottle:0,
      buttonText:"按钮",
      isDisplay:true,
      clicked: false
    },
    styleOption: {
      customClass:undefined,
      width: 0,
      height: 2,
      paddingLeft: 0
    },
    renderOption: {},
    event: {
      emit: [],
      on: []
    }
  },
  /*************************************
   *************************************
   *************    单行文本    **********
   *************************************
   *************************************/
  input: {
    node: {
      type: 'input',
      selfId: undefined,
      isCopied: false,
      copiedCount: 0
    },
    baseOption: {
      labelName:'单行文本',
      model: '',
      customName: '',
      defaultValue: '',
      placeholder: '',
      isClearable: false,
      isDisable: false,
      isDisplay: true,
      validator: {
        isRequire: false,
        ruleSelected: undefined,
        minValue: undefined,
        maxValue: undefined,
        isMoney: false
      }
    },
    renderOption: {
      strong: 'none',
      underline: 3,
      italic: 'none',
      wrap: false,
      lineHeight: '2.5',
      indent: 0,
      showRule: 'all',
      seat: '',
      nullRender : '1',
      whereColor: 'all',
      renderColor: '#5c5c5c',
      isUnderline: true
    },
    styleOption: {
      customClass: undefined,
      width: 5,
      height: 1.20,
      labelWidth: 2,
      labelPosition: 'left',
      labelTextPosition: 'left',
      showRule: 'all',
      paddingLeft: 0
    },
    event: {
      emit: [],
      on: []
    }
  },
  /*************************************
   *************************************
   *************    多行文本    **********
   *************************************
   *************************************/
  textarea: {
    node: {
      type: 'textarea',
      selfId: undefined,
      isCopied: false,
      copiedCount: 0
    },
    baseOption: {
      labelName: '多行文本',
      model: '',
      customName: '',
      defaultValue: '',
      autosize: {
        minRows: 2, 
        maxRows: 4
      },
      placeholder: '',
      isClearable: false,
      isDisable: false,
      isDisplay: true,
      validator: {
        isRequire: false,
        ruleSelected: undefined,
        minValue: undefined,
        maxValue: undefined,
        isMoney: false
      }
    },
    styleOption: {
      customClass: undefined,
      width: 5,
      height: 1.20,
      labelPosition: 'left',
      labelTextPosition: 'left',
      labelWidth: 2,
      paddingLeft: 0
    },
    renderOption: {
      strong: 'none',
      underline: 3,
      italic: 'none',
      wrap: false,
      lineHeight: '2.5',
      indent: 0,
      showRule: 'all',
      seat: '',
      nullRender : '1',
      whereColor: 'all',
      renderColor: '#5c5c5c',
      isUnderline: true
    },
    event: {
      emit: [],
      on: []
    }
  },
  /*************************************
   *************************************
   *************    单选框组    **********
   *************************************
   *************************************/
  radio: {
    node: {
      type: 'radio',
      selfId: undefined,
      isCopied: false,
      copiedCount: 0
    },
    baseOption: {
      labelName: '单选框组',
      model: '',
      customName: '',
      defaultValue: undefined,
      displayType: "inline-block",
      isDisable: false,
      options: [
        {
          value: '选项1',
          label: '选项1',
          node: {}
        },
        {
          value: '选项2',
          label: '选项2',
          node: {}
        }
      ],
      isDisplay: true,
      validator: {
        isRequire: false,
        ruleSelected: undefined,
        minValue: undefined,
        maxValue: undefined,
        isMoney: false
      }
    },
    styleOption: {
      customClass: undefined,
      labelPosition: 'left',
      labelTextPosition: 'left',
      labelWidth: 2,
      paddingLeft: 0
    },
    renderOption: {
      strong: 'none',
      underline: 3,
      italic: 'none',
      wrap: false,
      lineHeight: '2.5',
      indent: 0,
      showRule: 'all',
      nullRender : '1',
      whereColor: 'all',
      renderColor: '#5c5c5c',
      isUnderline: true
    },
    event: {
      emit: [],
      on: []
    }
  },
  /*************************************
   *************************************
   *************    多选框组    **********
   *************************************
   *************************************/
  checkbox: {
    node: {
      type: 'checkbox',
      selfId: undefined,
      isCopied: false,
      copiedCount: 0
    },
    baseOption: {
      labelName: '多选框组',
      defaultValue: [],
      customName: '',
      model: '',
      displayType: "inline-block",
      isDisable: false,
      options: [
        {
          value: '选项1',
          label: '选项1',
          node: {}
        },
        {
          value: '选项2',
          label: '选项2',
          node: {}
        }
      ],
      isDisplay: true,
      validator: {
        isRequire: false,
        ruleSelected: undefined,
        minValue: undefined,
        maxValue: undefined,
        isMoney: false
      }
    },
    styleOption: {
      customClass: undefined,
      labelPosition: 'left',
      labelTextPosition: 'left',
      labelWidth: 2,
      paddingLeft: 0
    },
    renderOption: {
      strong: 'none',
      underline: 3,
      italic: 'none',
      wrap: false,
      lineHeight: '2.5',
      indent: 0,
      showRule: 'all',
      nullRender : '1',
      whereColor: 'all',
      renderColor: '#5c5c5c',
      isUnderline: true
    },
    event: {
      emit: [],
      on: []
    }
  },
  /*************************************
   *************************************
   *************    下拉选择器    ********
   *************************************
   *************************************/
  select: {
    node: {
      type: 'select',
      selfId: undefined,
      isCopied: false,
      copiedCount: 0
    },
    baseOption: {
      labelName: '下拉选择器',
      model: '',
      customName: '',
      defaultValue: undefined,
      placeholder: '',
      multiple: false,
      isClearable: false,
      isDisable: false,
      options: [
        {
          value: '选项1',
          label: '选项1',
          node: {}
        },
        {
          value: '选项2',
          label: '选项2',
          node: {}
        }
      ],
      isDisplay: true,
      validator: {
        isRequire: false,
        ruleSelected: undefined,
        minValue: undefined,
        maxValue: undefined,
        isMoney: false
      }
    },
    styleOption: {
      customClass: undefined,
      width: 5,
      labelPosition: 'left',
      labelTextPosition: 'left',
      labelWidth: 2.5,
      paddingLeft: 0
    },
    renderOption: {
      strong: 'none',
      underline: 3,
      italic: 'none',
      wrap: false,
      lineHeight: '2.5',
      indent: 0,
      showRule: 'all',
      nullRender : '1',
      whereColor: 'all',
      renderColor: '#5c5c5c',
      isUnderline: true
    },
    event: {
      emit: [],
      on: []
    }
  },
  /*************************************
   *************************************
   *************    开关    *************
   *************************************
   *************************************/
  switch: {
    node: {
      type: 'switch',
      selfId: undefined,
      isCopied: false,
      copiedCount: 0
    },
    baseOption: {
      labelName: '开关',
      model: '',
      customName: '',
      defaultValue: undefined,
      isDisable: false,
      isDisplay: true
    },
    styleOption: {
      customClass: undefined,
      width: 5,
      height: 1.20,
      labelPosition: 'left',
      labelTextPosition: 'left',
      labelWidth: 2,
      paddingLeft: 0
    },
    renderOption: {
      strong: 'none',
      underline: 3,
      italic: 'none',
      wrap: false,
      lineHeight: '2.5',
      indent: 0,
      showRule: 'all',
      whereColor: 'all',
      renderColor: '#5c5c5c'
    },
    event: {
      emit: [],
      on: []
    }
  },
  /*************************************
   *************************************
   *************    日期选择器    ********
   *************************************
   *************************************/
  datePicker: {
    node: {
      type: 'datePicker',
      selfId: undefined,
      isCopied: false,
      copiedCount: 0
    },
    baseOption: {
      labelName: '日期选择器',
      model: '',
      customName: '',
      defaultValue: undefined,
      placeholder: '',
      dateType: undefined,
      dateFormat: undefined,
      dateFilter: [],
      isReadonly: false,
      isDisable: false,
      isEditable: false,
      isClearable: false,
      isDisplay: true,
      validator: {
        isRequire: false,
        ruleSelected: undefined,
        minValue: undefined,
        maxValue: undefined,
        isMoney: false
      }
    },
    styleOption: {
      customClass: undefined,
      width: 5,
      labelPosition: 'left',
      labelTextPosition: 'left',
      labelWidth: 2.5,
      paddingLeft: 0
    },
    renderOption: {
      strong: 'none',
      underline: 3,
      italic: 'none',
      wrap: false,
      lineHeight: '2.5',
      indent: 0,
      showRule: 'all',
      whereColor: 'all',
      renderColor: '#5c5c5c'
    },
    event: {
      emit: [],
      on: []
    }
  },
  /*************************************
   *************************************
   *************    时间选择器    ********
   *************************************
   *************************************/
  timePicker: {
    node: {
      type: 'timePicker',
      selfId: undefined,
      isCopied: false,
      copiedCount: 0
    },
    baseOption: {
      labelName: '时间选择器',
      model: '',
      customName: '',
      defaultValue: undefined,
      placeholder: '',
      isReadonly: false,
      isDisable: false,
      isEditable: false,
      isClearable: false,
      isDisplay: true,
      validator: {
        isRequire: false,
        ruleSelected: undefined,
        minValue: undefined,
        maxValue: undefined,
        isMoney: false
      }
    },
    styleOption: {
      customClass: undefined,
      width: 5,
      labelPosition: 'left',
      labelTextPosition: 'left',
      labelWidth: 2.5,
      paddingLeft: 0
    },
    renderOption: {
      strong: 'none',
      underline: 3,
      italic: 'none',
      wrap: false,
      lineHeight: '2.5',
      indent: 0,
      showRule: 'all',
      whereColor: 'all',
      renderColor: '#5c5c5c'
    },
    event: {
      emit: [],
      on: []
    }
  },
  /*************************************
   *************************************
   *************    分割线    ***********
   *************************************
   *************************************/
  line: {
    node: {
      type: 'line',
      selfId: undefined,
      isCopied: false,
      copiedCount: 0
    },
    baseOption: {
      labelName: '分割线',
      model: '',
      customName: '',
      defaultValue: undefined,
      lineText: '请在此输入文字',
      textPosition: 'flex-start',
      lineType: 'solid',
      isDisplay: true
    },
    styleOption: {
      customClass: undefined,
      width: 15,
      height: 2,
      paddingLeft: 0
    },
    renderOption: {
      strong: 'none',
      underline: 3,
      italic: 'none',
      wrap: false,
      lineHeight: '2.5',
      indent: 0
    },
    event: {
      emit: [],
      on: []
    }
  },
  /*************************************
   *************************************
   *************    上传图片    *********
   *************************************
   *************************************/
  uploadImage: {
    node: {
      type: 'uploadImage',
      selfId: undefined,
      isCopied: false,
      copiedCount: 0
    },
    baseOption: {
      labelName: '上传图片',
      model: '',
      customName: '',
      defaultValue: undefined,
      limit: 1,
      ossHost: "https://qjprod-images.oss-cn-beijing.aliyuncs.com",
      ossDir: "menuResource",
      ossRegion: "oss-cn-beijing",
      ossBucket: "qjprod-images",
      accessKeyId: "LTAIuBMF9MOPd8um",
      accessKeySecret: "xfMahp9yACASmfcHrRGyLDvL3HX8T8",
      isDisplay: true,
      validator: {
        isRequire: false
      }
    },
    styleOption: {
      width: 5,
      height: 1.20,
      labelPosition: 'left',
      labelTextPosition: 'left',
      labelWidth: 2,
      paddingLeft: 0
    },
    renderOption: {
      strong: 'none',
      underline: 3,
      italic: 'none',
      wrap: false,
      lineHeight: '2.5',
      indent: 0,
      showRule: 'all'
    },
    event: {
      emit: [],
      on: []
    }
  },
  /*************************************
   *************************************
   *************    上传文件    *********
   *************************************
   *************************************/
  uploadFile: {
    node: {
      type: 'uploadFile',
      selfId: undefined,
      isCopied: false,
      copiedCount: 0
    },
    baseOption: {
      labelName: '上传文件',
      model: '',
      customName: '',
      defaultValue: undefined,
      limit: 1,
      ossHost: "https://qjprod-images.oss-cn-beijing.aliyuncs.com",
      ossDir: "menuResource",
      ossRegion: "oss-cn-beijing",
      ossBucket: "qjprod-images",
      accessKeyId: "LTAIuBMF9MOPd8um",
      accessKeySecret: "xfMahp9yACASmfcHrRGyLDvL3HX8T8",
      isDisplay: true,
      validator: {
        isRequire: false
      }
    },
    styleOption: {
      width: 5,
      height: 1.20,
      labelPosition: 'left',
      labelTextPosition: 'left',
      labelWidth: 2,
      paddingLeft: 0
    },
    renderOption: {
      strong: 'none',
      underline: 3,
      italic: 'none',
      wrap: false,
      lineHeight: '2.5',
      indent: 0,
      showRule: 'all'
    },
    event: {
      emit: [],
      on: []
    }
  },
  /*************************************
   *************************************
   *************    栅格布局    *********
   *************************************
   *************************************/
  grid: {
    node: {
      type: 'grid',
      selfId: undefined,
      isCopied: false,
      copiedCount: 0
    },
    baseOption: {
      labelName: '栅格布局',
      customName: '',
      align: 'top',
      gutter: 0,
      justify: 'start',
      isDisplay: true
    },
    styleOption: {
      width: 5,
      height: 2,
      paddingLeft: 0
    },
    event: {
      emit: [],
      on: []
    }
  },
  /*************************************
   *************************************
   *************    栅格布局    *********
   *************************************
   *************************************/
  gridColumn: {
    node: {
      type: 'gridColumn',
      selfId: undefined,
      isCopied: false,
      copiedCount: 0
    },
    baseOption: {
      span: 12
    },
    styleOption: {
      paddingLeft: 0
    },
    event: {
      emit: [],
      on: []
    }
  },
  /*************************************
   *************************************
   *************    任意门    ***********
   *************************************
   *************************************/
  free: {
    node: {
      type: 'free',
      selfId: undefined,
      isCopied: false,
      copiedCount: 0
    },
    baseOption: {
      labelName: '任意门',
      customName: '',
      isDisplay: true
    },
    styleOption: {
      width: 5,
      height: 2,
      paddingLeft: 0
    },
    event: {
      emit: [],
      on: []
    }
  }
}
  
//  基本组件
export const baseComponents = [
  { type:'text',       name:'文字',     icon:'iconwords' },
  { type:'button',     name:'按钮',     icon:'iconbutton' },
  { type:'input',      name:'单行文本',  icon:'icontext' },
  { type:'textarea',   name:'多行文本',  icon:'icondomain' },
  { type:'radio',      name:'单选框组',  icon:'iconradio' },
  { type:'checkbox',   name:'多选框组',  icon:'iconcheckbox' },
  { type:'select',     name:'下拉选择器', icon:'icondropdown' },
  { type:'switch',     name:'开关',      icon:'iconswitch' },
  { type:'datePicker', name:'日期选择器', icon:'icondate' },
  { type:'timePicker', name:'时间选择器', icon:'icontime' },
  { type:'line',       name:'分割线',     icon:'iconline' }
]

// 高级组件
export const advancedComponents = [
  { type:'uploadImage', name:'上传图片', icon:'iconpicture' },
  { type:'uploadFile',  name:'上传文件', icon:'iconfile' }
]

// 布局组件
export const layoutComponents = [
  { type:'grid', name:'栅格布局', icon:'iconlayout' },
  { type:'free', name:'任意门',   icon:'iconlayout' }
]



// WEBPACK FOOTER //
// ./src/assets/js/form_dictionary.js